<template>
  <div>
    <div><a @click.stop.prevent="detailFun" style="text-decoration:none;cursor: pointer;">{{this.data.operateTitle}}</a><span style="margin-left: 15px;"></span>
      <!--<a v-show="this.data.deleteFlag" @click.stop.prevent="deletelFun">删除</a>-->
    </div>
  </div>
</template>

<script>
// import HandlerResTool from './resHandlerCommon';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'DetailTemplate',
  components: {

  },
  data() {
    return {
      data: {},
      url: '/lte/ems/',
    };
  },
  methods: {
    detailFun() {
      // 区分服务和实例-----idFlag:oamType_flag flag=0,服务，flag=1,实例
      const valueList = this.data.idFlag.split('_');
      // const oper = new HandlerResTool();
      // const param = {
      //   load: this.$loading,
      //   $axios: this.$axios,
      //   tipFlag: true
      // };
      if (valueList[0] === '0') { // 服务查看详情
        this.openServerDetailPage();
        // param.callFun = this.openServerDetailPage;
        // param.url = `${this.url}server/queryOne/-2`;
      } else if (valueList[0] === '1') { // 实例查看详情
        this.openDeployedDetailPage();
        // param.url = `${this.url}deployed/queryOne`;
        // param.callFun = this.openDeployedDetailPage;
      }
      // oper.$GetRequest(param);
    },
    openServerDetailPage() {
      // const param = {
      //   serviceId: this.data.serviceId, //typecode
      //   deployedCount: this.data.deployedCount, //部署数量
      // };
      const param = this.data;
      EventBus.$emit('openDetailPage', param);
    },
    openDeployedDetailPage() {
      // EventBus.$emit('openDetailPage', { serviceId: this.data.serviceId, envType: this.data.envType, envID: this.data.envID, k8sNodeId: this.data.dpId });
      const param = {
        neid: this.data.id?this.data.id:undefined,
        serviceId: this.data.serviceId, //判断类别
        envType: this.data.envType, //运行环境类型
        envID: this.data.envID,   //环境ID
        k8sNodeId: this.data.dpId, // 服务节点
        status: this.data.runState,  //运行状态（需后续在赋值）
        pkgVersion: this.data.version, //运行版本号
        createTime: this.data.createTime, //创建时间
        deliverTypeStr: this.data.deliverTypeStr,
        description: this.data.description,
        name: this.data.dname,
        serviceName: this.data.typeValue
      };
      EventBus.$emit('openDetailPage', param);
    },
    deletelFun() {
      // 先查询当前服务的所有版本----打开新的界面
      // this.$layer.confirm({
      //   title: 'info',
      //   msg: '此操作会删除当前服务的所有版本，确认删除吗？',
      //   btn2: {
      //     msg: '确认',
      //     func: () => {
      //       alert('删除方法还没写呢哈哈哈哈');
      //     }
      //   },
      //   btn1: {
      //     msg: '取消'
      //   }
      // });
      EventBus.$emit('deleteServer', { serviceId: this.data.serviceId, envType: this.data.envType, envID: this.data.envID, k8sNodeId: this.data.dpId });
    }
  },
};
</script>

<style scoped>

</style>
